/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Grouping } from 'cio/utils/metrics/common';
import { action } from '@ember/object';
import moment from 'moment-timezone';
import { DateRange } from '@customerio/fly-components/utils/fly-date-picker-utils';
import { DATE_RANGE_PRESETS, resolutionByRange } from 'cio/utils/campaigns/date-range';

interface CampaignsTableDatePickerSignature {
  Element: HTMLDivElement;
  Args: {
    range: DateRange;
    onRangeSelect: (range: DateRange, resolution: Grouping, preset?: string) => unknown;
    disabled?: boolean;
  };
}

export default class CampaignsTableDatePicker extends Component<CampaignsTableDatePickerSignature> {
  maxDate!: moment.Moment;
  maxRange = 730; // 2 years

  dateRangePresets = DATE_RANGE_PRESETS;

  constructor(owner: unknown, args: CampaignsTableDatePickerSignature['Args']) {
    super(owner, args);
    let now = moment.tz('Etc/UTC');
    this.maxDate = moment(`${now.format('YYYY-MM-DD')} 00:00:00`);
  }

  get disabled() {
    return this.args.disabled ?? false;
  }

  @action
  onRangeSelect(value: any) {
    if (value.date?.start == null || value.date?.end == null) {
      return;
    }

    let { start, end } = value.date as DateRange;

    let selectedPreset = this.dateRangePresets.find((preset) => {
      let presetRange = preset.getRange();

      if (presetRange.start == null || presetRange.end == null) {
        return false;
      }

      return presetRange.start.isSame(start) === true && presetRange.end.isSame(end) === true;
    });

    let resolution = resolutionByRange(value.date as DateRange);

    if (selectedPreset) {
      return this.args.onRangeSelect(selectedPreset.getRange(), resolution, selectedPreset.value);
    } else {
      if (resolution === Grouping.Hourly) {
        return this.args.onRangeSelect(
          {
            start: moment(value.date.start),
            end: moment(value.date.end).endOf('day'),
          },
          resolution,
        );
      }

      return this.args.onRangeSelect(
        {
          start: moment(value.date.start),
          end: moment(value.date.end),
        },
        resolution,
      );
    }
  }
}
